import type {SocialAccount} from '@Components/social-media/account.vo';
import {canInstagramAccountAddReelMusic} from '@Components/social-media/account.vo';
import type {InstagramReelMusic, SocialMediaPublishingParams} from '@Components/social-media/publish-params.types';
import type {MediaTypePublishingParams} from '@Components/social-media/post.vo';
import {useAllPublishingParamsForAccount} from '@Components/social-media/social-media.hooks';
import {updateInstagramReelMusic} from '@Components/social-media-wizard/social-media-wizard-reducer';
import type {InstagramAudioTrack} from '@Components/social-media-wizard/social-media-wizard.types';
import {getNonStoryPublishingParams, getReelMusicFromPublishingParams} from '@Libraries/social-media-params.library';
import {useAppDispatch} from '@/hooks';
import type {ReelMusicFieldState} from './reel-music-field.types';

export function useReelMusicField(account: SocialAccount, isVideoDesign: boolean): ReelMusicFieldState {
  const dispatch = useAppDispatch();
  const nonStoryPublishingParams = getNonStoryPublishingParamsOrNull(useAllPublishingParamsForAccount(account.id));

  const dispatchReelMusic = (reelMusic: InstagramReelMusic | null): void => {
    dispatch(updateInstagramReelMusic({idSocialMediaAccount: account.id, reelMusic}));
  };

  return {
    isAvailable: isVideoDesign && nonStoryPublishingParams !== null && canInstagramAccountAddReelMusic(account),
    reelMusic: getReelMusicFromPublishingParams(nonStoryPublishingParams),
    selectTrack: (track: InstagramAudioTrack): void => {
      dispatchReelMusic(track);
    },
    clearReelMusic: (): void => {
      dispatchReelMusic(null);
    },
  };
}

function getNonStoryPublishingParamsOrNull(allPublishingParamsForAccount: MediaTypePublishingParams | undefined): SocialMediaPublishingParams | null {
  if (!allPublishingParamsForAccount) {
    return null;
  }

  return getNonStoryPublishingParams(allPublishingParamsForAccount);
}
